"use client";

import NewEndorsement from "components/Modal/Endorsement/NewEndorsement";

export interface NewEndorsementModalContentV2Props {
  userId: string;
  skillId: string;
  name: string;
  onClose?: () => void;
}

export function NewEndorsementModalContentV2({
  userId,
  skillId,
  name,
}: NewEndorsementModalContentV2Props) {
  return <NewEndorsement userId={userId} skillId={skillId} name={name} />;
}
